// ApiServiceDGB.js

class ApiService {
    constructor(baseUrl, jwt) {
        this.baseUrl = baseUrl;
        this.jwt = jwt;
    }

    async request(endpoint, method = 'GET', body = null, isFormData = false) {
        const headers = {
            'Authorization': `Bearer ${this.jwt}`
        };

        if (!isFormData) {
            headers['Content-Type'] = 'application/json';
        }

        const options = {
            method,
            headers
        };

        if (body) {
            options.body = isFormData ? body : JSON.stringify(body);
            console.log("options.body: ", options.body);
        }

        try {
            const response = await fetch(`${this.baseUrl}${endpoint}`, options);

            if (!response.ok) {
                const errorData = await response.json(); // Await the JSON parsing
                console.log("API Error Response: ", errorData);
                throw new Error(errorData.errors ? errorData.errors[0].msg : 'Network response was not ok');
            }

            if (response.status === 204 || response.status === 201) {
                return response;
            }

            return await response.json();
        } catch (error) {
            console.error('Error making API call:', error);
            throw error;
        }
    }

    get(endpoint, body) {
        return this.request(endpoint, 'GET', body);
    }

    post(endpoint, body) {
        return this.request(endpoint, 'POST', body);
    }

    patch(endpoint, body) {
        return this.request(endpoint, 'PATCH', body);
    }

    put(endpoint, body) {
        return this.request(endpoint, 'PUT', body);
    }

    delete(endpoint) {
        return this.request(endpoint, 'DELETE');
    }

    // specific API route methods
    async addVin(businessRef, formData) {
        const headers = {
            'Authorization': `Bearer ${this.jwt}`
        };

        const options = {
            method: 'POST',
            headers,
            body: formData
        };

        try {
            const response = await fetch(`${this.baseUrl}/business/${businessRef}/cars`, options);

            if (!response.ok) {
                const errorBody = await response.json();
                let errorMessage;
                if (errorBody.errors?.[0]?.path) {
                    errorMessage = {
                        msg: errorBody.errors?.[0]?.msg,
                        path: errorBody.errors?.[0]?.path
                    };
                    const error = new Error(errorMessage.msg);
                    error.msg = errorMessage.msg;
                    error.path = errorMessage.path;
                    throw error;
                } else {
                    if (errorBody.errors?.[0]?.msg.toLowerCase().includes('invalid token') || response.statusText.toLowerCase().includes('invalid token')) {
                        window.location.replace(window.location.origin + '/logout');
                    }
                    throw new Error(errorBody.errors?.[0]?.msg || response.statusText);
                }
            }

            if (response.status === 201) {
                return response;
            }

            return await response.json();
        } catch (error) {
            console.error('Error adding VIN:', error);
            throw error;
        }
    }

    deleteVin(carId) {
        return this.delete(`/cars/${carId}/remove`);
    }

    getVinDetails(businessRef, vin) {
        return this.get(`/business/${businessRef}/cars?vin=${vin}`);
    }

    postTextMessage(businessRef, userId, phoneId, textMessage) {
        return this.post(`/business/${businessRef}/user/${userId}/phone/${phoneId}/send-message`, { textMessage });
    }

    addPhoneNumber(carId, phoneNumbers) {
        return this.post(`/cars/${carId}/add-phone`, { phone: phoneNumbers });
    }

    addPhoneNumberForExistingUser(carId, userId) {
        return this.post(`/cars/${carId}/add-user/${userId}`);
    }

    approvePhoneNumber(userId, phoneId) {
        return this.patch(`/user/${userId}/phone/${phoneId}/approve`);
    }

    editPhoneNumber(userId, phoneId, phoneNumber) {
        return this.patch(`/user/${userId}/phone/${phoneId}/edit`, { phone: phoneNumber });
    }

    deletePhoneNumber(carId, userId) {
        return this.delete(`/cars/${carId}/user/${userId}`)
    }

    searchPhoneNumber(businessRef, phoneNumber) {
        const formattedPhoneNumber = "+1" + phoneNumber.replace(/\D/g, '');
        const encodedPhoneNumber = encodeURIComponent(formattedPhoneNumber);
        return this.get(`/business/${businessRef}/search-phone?phone=${encodedPhoneNumber}`);
    }

    async uploadFiles(carId, formData) {
        return this.request(`/cars/${carId}/add-attachments`, 'POST', formData, true);
    }

    async deleteFile(carId, fileId) {
        return this.delete(`/cars/${carId}/attachment/${fileId}`);
    }
}

export default ApiService;
